import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import Template from './template.vue';
import AuthMixin from '@/mixins/AuthMixin';
import { Rol } from '@/store/modules/rol/types';
import RolForm from '@/components/RolForm/component';

const namespace: string = 'rolModule';

@Component({
  mixins: [Template, AuthMixin],
  components: { RolForm },
})
export default class Roles extends Vue {
  // tslint:disable-next-line: ban-types
  @Action('getRoles', { namespace }) private getRoles!: Function;
  @Getter('roles', { namespace }) private items!: Rol[];

  @State('error', { namespace }) private errorLoadingRoles!: boolean;
  @State('errorMessage', { namespace }) private errorMessage!: string;

  private buscador: string = '';
  private dialog: boolean = false;
  private rolSeleccionado: Partial<Rol> = {};
  private agregando: boolean = false;
  private gridHeaders: any = [
    { text: 'Nombre', value: 'name' },
    { text: 'Acciones', value: 'id', sortable: false },
  ];
  private gridPags: any = {
    rowsPerPage: 10,
  };

  private mounted() {
    this.getRoles();
  }

  private editaItem(item: Rol) {
    this.rolSeleccionado = item;
    this.agregando = false;
    this.dialog = true;
  }

  private eliminaItem(item: Rol) {
    //
  }

  private agregarItem() {
    this.rolSeleccionado = {};
    this.agregando = true;
    this.dialog = true;
  }

  private cerrarForma(ok: boolean) {
    this.dialog = false;
  }

}
